import Vue from 'vue'
import Router from 'vue-router'
import Home from '@/components/home'
import ContactUs from '@/components/contactUs'
import PurchasePage from '@/components/purchasePage'
import Order from '@/components/order'
import PaySuccess from '@/components/paySuccess'
import ActionPage from '@/components/actionPage'
import TransferPage from '@/components/transferPage'
import PrivacyTreaty from '@/components/privacyTreaty'
import CounselPaid from '@/components/counselPaid'
import map from '@/components/map'



Vue.use(Router)
const originalPush = Router.prototype.push
  Router.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)
}

export default new Router({
  mode:'history',
  routes: [
    {
      path: '/',
      name: 'home',
      component: Home,
    },
    {
      path: '/contactUs',
      name: 'contactUs',
      component: ContactUs
    },
    {
      path: '/purchasePage',
      name: 'purchasePage',
      component: PurchasePage
    },
    {
      path: '/order',
      name: 'order',
      component: Order
    },
    {
      path: '/paySuccess',
      name: 'paySuccess',
      component: PaySuccess
    },
    {
      path: '/actionPage',
      name: 'actionPage',
      component: ActionPage
    },
    {
      path: '/transferPage',
      name: 'transferPage',
      component: TransferPage
    },
    {
      path: '/privacyTreaty',
      name: 'privacyTreaty',
      component: PrivacyTreaty
    },
    // {
    //   path: '/counselPaid',
    //   name: 'counselPaid',
    //   component: CounselPaid
    // },
    {
      path: '/map',
      name: 'map',
      component: map
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js